const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://k0bz9xsmf2.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://v8178qria4.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.4',
    HOSTNAME: 'https://company.staging.newmont.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.newmont.forwoodsafety.com',
    WEBSOCKET: 'wss://qie4vjq8uj.execute-api.us-west-2.amazonaws.com/staging'
  },
};

export default config;